<template>
  <div id="validate-account">
    <div id="expiry-message">
      <div
        class="spinner-border"
        role="status"
        v-if="$store.getters['loadings/isLoading']"
      >
        <span class="visually-hidden">{{ $t(`message.loading`) }}...</span>
      </div>
      <div id="main-container" v-else>
        <p class="message-validation-expired">
          <b>{{ $t(`message.validationExpired`) }}</b>
        </p>
        <form @submit.prevent="checkForm" novalidate="true">
          <div class="mail-input-wrapper">
            <input
              type="email"
              class="form-control w-50"
              :placeholder="$t(`message.email`)"
              v-model="email"
              required
            />
          </div>
          <div class="submit-wrapper">
            <button type="submit" class="pill">
              {{ $t(`message.submit`) }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ValidateAccount",
  data() {
    return {
      display_form: false,
      email: "",
    };
  },
  methods: {
    checkForm() {
      // Reset token, resend mail
      this.$store
        .dispatch("users/resetEmailValidationToken", { email: this.email })
        .then(() => {
          this.$router.push({ name: "HomePage" });
          this.$store.dispatch(
            "notifications/addSuccess",
            {
              message: this.$t(`message.notifications.validationMailResent`),
            },
            { root: true },
          );
        })
        .catch(() => {
          this.$store.dispatch(
            "notifications/addError",
            { message: this.$t(`message.notifications.errorCheckEmail`) },
            { root: true },
          );
        })
        .finally(() => {
          this.$store.dispatch("loadings/disableLoadings", {}, { root: true });
        });
    },
  },
  created() {
    this.$store.dispatch("users/logout");

    if (!this.$route.query.token) {
      this.$router.push({ name: "HomePage" });
    } else {
      this.$store
        .dispatch("users/validateAccount", this.$route.query.token)
        .then(() => {
          this.$router.push({ name: "AppLogin" });
          this.$store.dispatch(
            "notifications/addSuccess",
            { message: this.$t(`message.notifications.mailValidated`) },
            { root: true },
          );
        })
        .catch((error) => {
          if (error.response.status == 410) {
            this.display_form = true;
          } else {
            if (error.response.status == 404) {
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(
                    `message.notifications.mailValidationTokenNotFound`,
                  ),
                },
                { root: true },
              );
            } else {
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(
                    `message.notifications.errorValidatingEmail`,
                  ),
                },
                { root: true },
              );
            }

            this.$router.push({ name: "HomePage" });
          }
        })
        .finally(() => {
          this.$store.dispatch("loadings/disableLoadings", {}, { root: true });
        });
    }
  },
};
</script>

<style lang="scss" scoped>
#validate-account {
  position: relative;
  display: flex;
  min-height: calc(100vh - 115px - 126px - 40px);
  margin-bottom: 15px;

  #expiry-message {
    background-color: $primaryColorLight;
    border-radius: 50px;
    margin: 0 auto;
    width: 93%;
    min-height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1em 1em;
    text-align: center;
    height: 100%;

    #main-container {
      .message-validation-expired {
        margin-bottom: 1.5rem;
      }

      .mail-input-wrapper {
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
      }

      input {
        box-shadow: none !important;
        max-height: 2.5rem;
      }

      .submit-wrapper {
        display: flex;
        justify-content: center;
      }

      .pill {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        border: 3px solid $secondaryColor;
        background-color: $secondaryColor;
        color: $whiteColor;
        height: 40px;
        border-radius: 20px;

        &:hover {
          border: 3px solid $secondaryColor;
          color: $secondaryColor;
          background-color: $backgroundColor;
        }
      }
    }
  }
}
</style>
